export default __webpack_public_path__ + "static/media/Artic ice4.9c28ef10.jpg";